// extracted by mini-css-extract-plugin
module.exports = {"label":"_2S3IqVmsUN8BXE64sLNs66","icon":"_2S1sTgAAHbNGo3YySixzPP","labelText":"_3izRBNEON8q67FmQy2blsR"};